import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthContext } from '../../hooks/useAuthContext';
import ItemEditor from '../../components/ItemEditor/ItemEditor';
import CategoryItemList from '../../components/CategoryItemList/CategoryItemList';
import Drawer from '../../components/Drawer/Drawer';
import { apiFetch } from '../../utils/api';
import Spinner from '../../components/Spinner/Spinner';
import Breadcrumb from '../../components/Breadcrumb/Breadcrumb';
import BackLink from '../../components/BackLink/BackLink';
import Button from '../../components/Button/Button';
import './CategoryDetailsPage.css';

const CategoryDetailsPage = () => {
  const { id } = useParams();
  const { user } = useAuthContext();
  const navigate = useNavigate();
  const [category, setCategory] = useState(null);
  const [loading, setLoading] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const fetchCategory = async () => {
    setLoading(true);
    const res = await apiFetch(`/api/admin/categories/${id}`, {
      headers: { Authorization: `Bearer ${user.token}` },
    });
    const data = await res.json();
    setCategory(data);
    setLoading(false);
  };

  useEffect(() => {
    fetchCategory();
  }, [id]);

  const handleItemAdded = () => {
    setDrawerOpen(false);
    fetchCategory();
  };

  const handleItemDeleted = async (itemId) => {
    await apiFetch(`/api/admin/categories/${id}/items/${itemId}`, {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${user.token}` },
    });
    setCategory(prev => ({ ...prev, items: prev.items.filter(i => i._id !== itemId) }));
  };

  if (loading) return <Spinner />;
  if (!category) return <div>Category not found.</div>;

  const categoryName = category.translations?.en ?? category.title ?? 'Category';

  return (
    <div className="category-details-page">
      <Breadcrumb items={[
        { label: 'Categories', to: '/categories' },
        { label: categoryName },
      ]} />

      <BackLink to="/categories" label="Back to Categories" />

      <div className="category-details-header">
        <h2>{categoryName}</h2>
        <Button variant="secondary" onClick={() => setDrawerOpen(true)}>
          Add New Item
        </Button>
      </div>

      <CategoryItemList
        items={category.items}
        onDelete={handleItemDeleted}
        onItemClick={(itemId) => navigate(`/categories/${id}/items/${itemId}`)}
      />

      <Drawer open={drawerOpen} onClose={() => setDrawerOpen(false)} title="Add New Item">
        <ItemEditor categoryId={id} onSuccess={handleItemAdded} />
      </Drawer>
    </div>
  );
};

export default CategoryDetailsPage;
